import { toast } from "react-toastify";
import { put, call, delay } from "redux-saga/effects";
import { GET, POST, PUT, PUT_CUSTOM } from "../../../../services/api";

export function* updateTemplate(action) {
  const result = yield call(PUT_CUSTOM, {
    endpoint: `/templates/image`,
    data: action.payload,
  });
  if (result === false) {
    yield put({ type: "CONFIG_UPDATE_ERROR" });
  } else {
    yield put({ type: "CONFIG_UPDATE_SUCCESS", payload: result.data });
    toast.success("Suas atualizações foram salvas com sucesso!");

    yield put({ type: "SAGA_GET_TEMPLATES" });

    // yield put({ type: "CONFIG_CONTROL_SET", payload: result.data[0] })

    // yield put({ type: "CONFIG_CONTROL_SAVE_EMAIL_SET", payload: true })
  }
}

export function* updateWatermark(action) {
  console.log("updateWatermark",action.payload)
  
  const toastId = toast.loading("Aguarde...");

  yield delay(2000)
  
  const result = yield call(PUT_CUSTOM, { endpoint: `/templates/watermark`, data: action.payload, });
  if (result === false) {
    toast.update(toastId, {
      render: "Erro ao salvar as configurações",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    yield put({ type: "SAGA_UPDATE_WATERMARK_ERROR" });
  } else {
    toast.update(toastId, {
      render: "Salvo com sucesso!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    yield put({ type: "SAGA_UPDATE_WATERMARK_SUCCESS", payload: result.data });

    yield put({ type: "SAGA_GET_TEMPLATES" });
  }
}

export function* getTemplate(action) {
  const result = yield call(GET, { endpoint: `/templates${action?.payload?.email_editor ? '?email_editor=true' : ''}`, });
  yield put({ type: "GET_TEMPLATES_SUCCESS", payload: result.data });

  // Clear local-only watermark fields so dirty state resets after save/discard
  const template = result.data[0] || {};
  yield put({
    type: "CONFIG_CONTROL_SET",
    payload: {
      ...template,
      watermark_image_file: null,
      watermark_image: template.watermark_image ?? null,
    },
  });

  yield put({ type: "CONFIG_CONTROL_SAVE_CHECKOUT_SET", payload: true })

  yield put({ type: "CONFIG_CONTROL_SAVE_EMAIL_SET", payload: true })
}


export function* sendEmailTeste(action) {
  yield put({ type: "EMAIL_TESTE_REQUEST" });
  const result = yield call(POST, { endpoint: `/emailpreview`, data: action.payload });
  if (result == false) {
    yield put({ type: "EMAIL_TESTE_ERROR" });
  } else {
    yield put({ type: "EMAIL_TESTE_SUCCESS", payload: result.data });
  }
}

export function* changeStatusDownload(action) {
  yield put({ type: "CHANGE_STATUS_DOWNLOAD_REQUEST" });
  //yield delay(2000)
  const result = yield call(PUT, { endpoint: `integrations/scriptdownload`, data: action.payload });
  if (result == false) {
    yield put({ type: "CHANGE_STATUS_DOWNLOAD_ERROR" });
  } else {
    yield put({ type: "CHANGE_STATUS_DOWNLOAD_SUCCESS", payload: result.data });
  }
}